<div class="mb-6">
  {{ 'workCouncil.confirmationModal.subHeading.' + selectedStatus | translate: { name: profileFullName } }}
</div>

<form [ngClass]="{ 'was-validated': submitted }">
  <div>
    <label [ngClass]="{ required: hasDisapproveStatus }">
      {{ ((hasDisapproveStatus ? 'workCouncil.confirmationModal.reason.disapprove' : 'comment') | translate) + ':' }}
    </label>
  </div>
  <base-input
    [size]="inputSizes.lg"
    [isInvalid]="!!reasonFormControl?.errors"
    [errorMessage]="reasonFormControl?.errors | baseFieldValidation"
    [isRequired]="hasDisapproveStatus"
    placeholder="workCouncil.confirmationModal.placeholder.{{ selectedStatus }}"
    [formControl]="reasonFormControl"
  ></base-input>
</form>

<div class="my-6">{{ 'workCouncil.confirmationModal.noteText.' + selectedStatus | translate }}</div>

<div class="d-flex mb-5 justify-content-between align-items-center">
  <base-button
    color="secondary"
    label="action.cancel"
    (btnClick)="onClose()"
  ></base-button>
  <base-button
    color="primary"
    label="workCouncil.confirmationModal.yesBtn.{{ selectedStatus }}"
    (btnClick)="onConfirm()"
  ></base-button>
</div>
